import api from '@/lib/api'

const LOCAL_USER_KEY = 'account'

function setLocalUser(user) {
	const payload = JSON.stringify(user)
	localStorage.setItem(LOCAL_USER_KEY, payload)
}

function removeLocalUser() {
	localStorage.removeItem(LOCAL_USER_KEY)
}

function getLocalUser() {
	const payload = localStorage.getItem(LOCAL_USER_KEY)
	if (!payload) return undefined
	try {
		// Parse and return local user
		return JSON.parse(payload)
	} catch (err) {
		// Local user may be corrupt
		removeLocalUser()
		return undefined
	}
}

const state = {
	loading: false,
	user: null,
}

// prettier-ignore
const mb=p=>o=>p.map(c=>o=(o||{})[c])&&o

const getters = {
	loggedIn: state => state.user !== null,
	email: mb(['user', 'email']),
	permissionLevel: mb(['user', 'permissionLevel']),
}

const mutations = {
	setLoading(state, loading) {
		state.loading = loading
	},
	logIn(state, user) {
		state.user = user
		setLocalUser(user)
	},
	logOut(state) {
		state.user = null
		removeLocalUser()
	},
}

const actions = {
	async init({ commit }) {
		// Check if local user exists
		const localUser = getLocalUser()

		if (localUser) {
			// Log in using local user
			commit('logIn', localUser)

			// Check to see if session is still valid
			commit('setLoading', true)
			try {
				// Update local user with remote user
				const user = await api.get('/account')
				commit('logIn', user)
			} finally {
				commit('setLoading', false)
			}
		}
	},
	async logIn({ commit }, creds) {
		commit('setLoading', true)
		try {
			// Log in via API
			const user = await api.post('/login', creds)
			commit('logIn', user)
			return true
		} catch (err) {
			return false
		} finally {
			commit('setLoading', false)
		}
	},
	async logOut({ commit, dispatch }) {
		commit('setLoading', true)
		try {
			// End session
			await api.get('/logout')
			commit('logOut')

			// Send confirmation toast
			dispatch('toast/push', { message: 'You were successfully logged out.' }, { root: true })
			return true
		} catch (err) {
			return false
		} finally {
			commit('setLoading', false)
		}
	},
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true,
}
